import { css } from 'styled-components';
export var accordionHeading = /*#__PURE__*/css(["display:block;list-style:none;&::-webkit-details-marker{display:none;}"]);
export var accordionItem = /*#__PURE__*/css(["display:block;&:last-of-type{border-bottom:1px solid var(--neutral-black-30);}"]);